import toast from "react-hot-toast";
import { set_uploads } from "../_store/reducers/planReducer";


// Toaster functions
export const notifySuccess = (msg) => toast.success(msg);

export const notifyError = (msg) => toast.error(msg);

//i can pass timeout to the toast.warning
export const notifyWarning = (msg, timeout = 3000) =>
  toast.custom((t) => (
    <div
      style={{
        padding: "12px 16px",
        background: "#fff8e1",
        color: "#7a4f01",
        border: "1px solid #fce4a0",
        borderRadius: "6px",
        fontSize: "14px",
        display: "flex",
        alignItems: "center",
        gap: "10px",
        minWidth: "250px",
        boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
      }}
    >
      <span style={{ fontSize: "18px" }}>⚠️</span>

      <span style={{ flex: 1 }}>{msg}</span>

      {/* Close Button */}
      <button
        onClick={() => toast.dismiss(t.id)}
        style={{
          background: "transparent",
          border: "none",
          cursor: "pointer",
          fontSize: "16px",
          color: "#7a4f01",
        }}
      >
        ✕
      </button>
    </div>
  ), {
    duration: timeout
  });
// Email formatting function
export const getFormattedEmail = (email) => {
  const [name, domain] = email.split("@");
  let formattedEmail = "";
  for (let i = 0; i < name.length; i++) {
    if (i < 3) {
      formattedEmail += name[i];
    } else {
      formattedEmail += "*";
    }
  }
  return `${formattedEmail}@${domain}`;
};


// Auth token functions
export const saveAuthToken = (token) => {
  localStorage.setItem("access_token_AS", token);
};

/**
 * Updates sessionStorage and Redux store with user permissions and plan info
 * @param {Object} data - Response data from getUserProfile API
 * @param {Function} dispatch - Redux dispatch function
 */
export const updateUserSessionData = (data, dispatch) => {
  if (!data || !dispatch) {
    console.error("updateUserSessionData: data and dispatch are required");
    return;
  }

  // Update sessionStorage for permissions
  if (data.modulePermissions) {
    sessionStorage.setItem(
      "permissions",
      JSON.stringify(data.modulePermissions)
    );
    // Dispatch custom event to notify other components (like Navbar) that permissions were updated
    window.dispatchEvent(new CustomEvent("permissionsUpdated"));
  }

  // Update sessionStorage for plan info
  if (data.planInfo) {
    sessionStorage.setItem("planInfo", JSON.stringify(data.planInfo));
  }

  // Update Redux store for remaining uploads
  if (data.planInfo) {
    let remainingUploads = 0;
    const planInfo = data.planInfo;
    
    if (planInfo?.max_credits === -1) {
      remainingUploads = "Unlimited";
    } else {
      remainingUploads = (planInfo?.max_credits || 0) - (planInfo?.used_credits || 0);
    }
    
    dispatch(set_uploads(remainingUploads));
  }
};

export const deleteAuthToken = () => {
  localStorage.removeItem("access_token_AS");
};

export function isValidEmail(email) {
  // Regular expression for basic email validation
  const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  // Test the email against the regular expression
  return emailRegex.test(email);
}


export function isValidPhoneNumber(phone) {
  const phoneRegex = /^[0-9]{10}$/;
  return phoneRegex.test(phone);
}

export function isValidPassword(password){
  const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/;
  return passwordRegex.test(password)
}

export function isValidName(name){

  //name should at least 3 characters long and should not contain numbers or special characters and at max 30 chars
  const nameRegex = /^[a-zA-Z\s]{3,30}$/;
  return nameRegex.test(name);

}



